import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import routes from "./AdminRoute";
// import Footer from "./Header/Footer";

import "./assets/css/styles.css";
import AdminSidebar from "../../Layouts/AdminSidebar";
import AdminNavbar from "../../Layouts/AdminNavbar";

const MasterLayout = () => {
  return (
    <div className="sb-nav-fixed">
      <AdminNavbar />
      <div id="layoutSidenav">
        <div id="layoutSidenav_nav">
          <AdminSidebar />
        </div>

        <div id="layoutSidenav_content">
          <main className="p-3 h-100" style={{ background: "#151515" }}>
            <Switch>
              {routes.map((route, idx) => {
                return (
                  route.component && (
                    <Route
                      key={idx}
                      path={route.path}
                      exact={route.exact}
                      name={route.name}
                      render={(props) => <route.component {...props} />}
                    />
                  )
                );
              })}
              <Redirect
                from="/superstar-admin"
                to="/superstar-admin/dashboard"
              />
            </Switch>
          </main>

          {/*<Footer></Footer>*/}
        </div>
      </div>
    </div>
  );
};

export default MasterLayout;
